"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _authenticate = require("./authenticate");
Object.keys(_authenticate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _authenticate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authenticate[key];
    }
  });
});
var _create = require("./create");
Object.keys(_create).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _create[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _create[key];
    }
  });
});
var _merge = require("./merge");
Object.keys(_merge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _merge[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _merge[key];
    }
  });
});
var _expand = require("./expand");
Object.keys(_expand).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _expand[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _expand[key];
    }
  });
});
var _email = require("./email");
Object.keys(_email).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _email[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _email[key];
    }
  });
});
var _phone = require("./phone");
Object.keys(_phone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _phone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _phone[key];
    }
  });
});